import cx from 'classnames';
import {type FC, type MouseEventHandler, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {selectActiveFilterCount} from '~/GalleryPB/reducers/filters';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useIsLargeAndUp} from '~library/hooks/useMatchQuery';
import {FiltersIcon} from '~library/svg/FiltersIcon';

import * as styles from './FiltersButton.module.scss';

interface FiltersButtonProps {
  areFiltersOpen?: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const FiltersButton: FC<FiltersButtonProps> = ({areFiltersOpen = false, onClick}) => {
  const isLargeAndUp = useIsLargeAndUp();
  const activeFilterCount = useSelector(selectActiveFilterCount);
  const buttonText = useMemo(() => {
    if (!isLargeAndUp) return 'Filters & sort';
    return areFiltersOpen ? 'Hide filters' : 'Show filters';
  }, [areFiltersOpen, isLargeAndUp]);
  return (
    <Button
      onClick={onClick}
      variant="secondary"
      size={isLargeAndUp ? 'medium' : 'small'}
      data-qa-id="button-open-filters"
      className={cx({[styles.filtersButtonActive]: activeFilterCount > 0})}
    >
      <FiltersIcon ratio={0.75} />
      {buttonText}
      {activeFilterCount > 0 && (
        <div className={styles.activeFilterCounter} data-qa-id="active-filters-count">
          <Typography variant="paragraph4" color="white">
            {activeFilterCount}
          </Typography>
        </div>
      )}
    </Button>
  );
};
